function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#247dbd;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 0,
  y: 0,
  width: 50,
  height: 50,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 9)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "matrix(1, 0, 0, 1, -9, -9)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(9 9)"
})), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M5,0l5,9H0Z",
  transform: "translate(21 22) rotate(180)"
}));

const SvgIconDropdown = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDropdown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Dropdown.8fa0e6c6.svg";
export { ForwardRef as ReactComponent };